import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slide", "dot"];
  static values = {
    interval: { type: Number, default: 5000 },
    autoplay: { type: Boolean, default: true }
  };

  connect() {
    if (this.autoplayValue) {
      this.startAutoplay();
    }
  }

  disconnect() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  startAutoplay() {
    this.autoplayInterval = setInterval(() => {
      this.next();
    }, this.intervalValue);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }

  next() {
    const currentSlideIndex = this.slideTargets.findIndex((slide) =>
      slide.classList.contains("active")
    );
    const nextSlideIndex = (currentSlideIndex + 1) % this.slideTargets.length;
    const nextSlide = this.slideTargets[nextSlideIndex];

    this.showSlide(nextSlide);
  }

  previous() {
    const currentSlideIndex = this.slideTargets.findIndex((slide) =>
      slide.classList.contains("active")
    );
    const previousSlideIndex =
      (currentSlideIndex - 1 + this.slideTargets.length) %
      this.slideTargets.length;
    const previousSlide = this.slideTargets[previousSlideIndex];

    this.showSlide(previousSlide);
  }

  showSlide(targetSlide) {
    // Remove active class from all slides and dots
    this.slideTargets.forEach((slide) => slide.classList.remove("active"));
    this.dotTargets.forEach((dot) => {
      dot.classList.remove("active");
      dot.classList.remove("bg-irish-green");
      dot.classList.add("bg-off-white");
    });

    // Add active class to target slide
    targetSlide.classList.add("active");

    // Find and activate corresponding dot
    const slideIndex = this.slideTargets.indexOf(targetSlide);
    if (this.dotTargets[slideIndex]) {
      this.dotTargets[slideIndex].classList.remove("bg-off-white");
      this.dotTargets[slideIndex].classList.add("bg-irish-green");
      this.dotTargets[slideIndex].classList.add("active");
    }
  }

  goToSlide(event) {
    const slideIndex = parseInt(event.currentTarget.dataset.slideIndex);
    const targetSlide = this.slideTargets[slideIndex];

    if (targetSlide) {
      this.showSlide(targetSlide);
    }
  }
}
